<template>
  <b-card no-body class="filters">
    <b-tabs card v-model="tabIndex">
      <b-tab :title="$gettext('Quick Filters')">
        <b-card-text>
          <b-row v-if="!quickFilters.actionsShowIf || quickFilters.actionsShowIf()">
            <b-col class="text-center filter-actions">
              <b-button
                v-if="quickFilters.manualApply"
                size="sm"
                variant="success"
                :disabled="Boolean(quickFilters.applyDisabledIf && quickFilters.applyDisabledIf(state))"
                @click="emitQuickFilters"
                v-translate
              >
                Apply Filters
              </b-button>
              <b-badge size="md" @click="resetQuickFilters" v-translate>Reset Filters</b-badge>&nbsp;
              <b-badge size="sm" @click="saveCurrentSearch('quick')" v-translate>Save this Filters' Set</b-badge>
            </b-col>
          </b-row>
          <layout-renderer :layout="quickFilters.layout">
            <template #field="{ fieldKey }">
              <div v-if="isVisible(fieldKey)" class="form-group">
                <label v-if="filterByName[fieldKey].type !== 'checkbox' && filterByName[fieldKey].type !== 'daterange'" :for="'quick-filter-' + fieldKey">{{ filterByName[fieldKey].label }}</label>
                <template v-if="filterByName[fieldKey].type === 'daterange'">
                  <label :for="'quick-filter-' + fieldKey">{{ filterByName[fieldKey].label }}</label><label v-show="state[fieldKey].active !== 0">&nbsp;[<a href="#" @click.prevent="resetDateRange(fieldKey)" v-translate>reset range</a>]</label>
                  <date-range-picker
                    :id="'quick-filter-' + fieldKey"
                    :date-range="{ startDate: state[fieldKey].startDate, endDate: state[fieldKey].endDate }"
                    @update="onDateRangeUpdate(fieldKey, $event)"
                    :locale-data="dateRangeLocale"
                    :opens="filterByName[fieldKey].opens || 'right'"
                    class="mb-2 w-100"
                    :ranges="dateRangeRanges"
                    :min-date="dateRangeMinDates[fieldKey] || null"
                    :max-date="dateRangeMaxDate(fieldKey)"
                    @start-selection="onDateRangeStartSelection(fieldKey, $event)"
                    @toggle="onDateRangeToggle(fieldKey, $event)"
                  >
                    <div slot="input" slot-scope="picker">
                      <font-awesome-icon :icon="['far', 'calendar-alt']" size="1x" style="vertical-align: middle" />
                      <span v-if="state[fieldKey].active === 0" style="vertical-align: middle">...</span>
                      <span v-else style="vertical-align: middle">{{moment(state[fieldKey].startDate).format('L')}} - {{moment(state[fieldKey].endDate).format('L')}}</span>
                    </div>
                  </date-range-picker>
                </template>
                <b-form-checkbox
                  v-else-if="filterByName[fieldKey].type === 'checkbox'"
                  :id="'quick-filter-' + fieldKey"
                  v-model="state[fieldKey]"
                  :value="filterByName[fieldKey].checkedValue === undefined ? true : filterByName[fieldKey].checkedValue"
                  :disabled="isDisabled(fieldKey)"
                >{{ filterByName[fieldKey].label }}</b-form-checkbox>
                <b-form-checkbox-group
                  v-else-if="filterByName[fieldKey].type === 'checkbox-group'"
                  stacked
                  :id="'quick-filter-' + fieldKey"
                  v-model="state[fieldKey]"
                  :options="optionsFor(fieldKey)"
                ></b-form-checkbox-group>
                <b-form-radio-group
                  v-else-if="filterByName[fieldKey].type === 'radio-group'"
                  stacked
                  :id="'quick-filter-' + fieldKey"
                  v-model="state[fieldKey]"
                  :options="optionsFor(fieldKey)"
                ></b-form-radio-group>
                <b-form-select
                  v-else-if="filterByName[fieldKey].type === 'select'"
                  :id="'quick-filter-' + fieldKey"
                  v-model="state[fieldKey]"
                  :options="optionsFor(fieldKey)"
                ></b-form-select>
                <div v-else-if="filterByName[fieldKey].type === 'autocomplete'">
                  <component
                    :is="filterByName[fieldKey].component"
                    :ref="'autocomplete-' + fieldKey"
                    v-bind="filterByName[fieldKey].componentProps || {}"
                    @selected="onAutocompleteSelected(fieldKey, $event)"
                  ></component>
                  <b-badge v-for="(item, index) in state[fieldKey]" :key="index">
                    {{ item[filterByName[fieldKey].displayField || 'name'] }}
                    <b-badge variant="danger" href="#" @click.prevent="state[fieldKey].splice(index, 1)">×</b-badge>
                  </b-badge>
                </div>
                <textarea
                  v-else-if="filterByName[fieldKey].type === 'textarea'"
                  :id="'quick-filter-' + fieldKey"
                  v-model.lazy="state[fieldKey]"
                  class="mb-2 col-12 form-control"
                  :placeholder="filterByName[fieldKey].placeholder || ''"
                ></textarea>
                <input
                  v-else
                  :id="'quick-filter-' + fieldKey"
                  v-model.lazy="state[fieldKey]"
                  :type="filterByName[fieldKey].inputType || 'text'"
                  class="mb-2 col-12 form-control"
                  :placeholder="filterByName[fieldKey].placeholder || ''"
                />
              </div>
            </template>
          </layout-renderer>
        </b-card-text>
      </b-tab>
      <b-tab :title="$gettext('Advanced Filters')" v-if="!quickFilters.showAdvanced || quickFilters.showAdvanced()">
        <b-card-text>
          <b-row>
            <b-col lg="12" class="my-1">
              <listing-filter
                ref="listingFilter"
                :type="type"
                :pre-filters="preFilters"
                @refresh="onAdvancedRefresh"
                @save-filter="saveCurrentSearch('advanced')"
              />
            </b-col>
          </b-row>
        </b-card-text>
      </b-tab>
      <b-tab :title="$gettext('Saved Filters')" :disabled="savedSearches.length === 0" v-if="!quickFilters.showSaved || quickFilters.showSaved()">
        <b-list-group>
          <b-list-group-item
            v-for="(saved, index) in savedSearches"
            :key="index"
            href="#"
            @click.prevent="applySavedSearch(saved)"
            class="d-flex justify-content-between align-items-center"
          >
            {{ saved.name }}
            <b-badge href="#" @click.stop.prevent="deleteSavedSearch(index)" variant="danger">✕</b-badge>
          </b-list-group-item>
        </b-list-group>
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
import LayoutRenderer from '@/components/Engine/LayoutRenderer'
import ListingFilter from '@/components/Engine/ListingFilter'
import DateRangePicker from 'vue2-daterange-picker'

/**
 * Motor de filtros Quick/Advanced/Saved (MOOV-5200).
 *
 * Quick: renderiza una definición declarativa ({filters, layout}, ver
 * src/common/quickFiltersDefinitions/) vía LayoutRenderer; cada callback
 * devuelve triples [[col, op, val]], un grupo {or: true, filters} o [].
 * Emite `filtering` con {filters, groups}; el estado vive en ?qf= (control
 * values) y se aceptan las URLs legacy ?qs= (triples) de los forks.
 * Saved: objetos {name, tab, state} en localStorage.savedSearches[type];
 * las keys legacy por fork ({name, url}) se migran una sola vez sin borrarlas.
 */
export default {
  name: 'ListFilters',
  components: {
    LayoutRenderer,
    ListingFilter,
    DateRangePicker
  },
  props: {
    type: {
      type: String,
      required: true
    },
    quickFilters: {
      type: Object,
      required: true
    },
    preFilters: {
      type: Array,
      default: () => {
        return []
      }
    },
    legacySavedKey: {
      type: String,
      default: null
    }
  },
  data () {
    const state = {}
    for (const filter of this.quickFilters.filters) {
      state[filter.name] = filter.value === undefined ? null : JSON.parse(JSON.stringify(filter.value))
    }
    return {
      tabIndex: 0,
      state,
      savedSearches: [],
      dateRangeMinDates: {}
    }
  },
  computed: {
    filterByName () {
      const map = {}
      for (const filter of this.quickFilters.filters) {
        map[filter.name] = filter
      }
      return map
    },
    dateRangeLocale () {
      return {
        direction: 'ltr',
        format: 'dd/mm/yyyy',
        separator: ' - ',
        applyLabel: this.$gettext('Apply'),
        cancelLabel: this.$gettext('Cancel'),
        weekLabel: 'W',
        customRangeLabel: this.$gettext('Custom Range'),
        daysOfWeek: this.moment.weekdaysMin(),
        monthNames: this.moment.monthsShort(),
        firstDay: 1,
        showWeekNumbers: false
      }
    },
    dateRangeRanges () {
      return {
        [this.$gettext('Today')]: [this.moment().toDate(), this.moment().toDate()],
        [this.$gettext('Yesterday')]: [this.moment().subtract(1, 'days').toDate(), this.moment().subtract(1, 'days').toDate()],
        [this.$gettext('Last 7 days')]: [this.moment().subtract(6, 'day').startOf('day').toDate(), this.moment().subtract(0, 'day').endOf('day').toDate()],
        [this.$gettext('Last 30 days')]: [this.moment().subtract(29, 'day').startOf('day').toDate(), this.moment().subtract(0, 'day').endOf('day').toDate()],
        [this.$gettext('Last 120 days')]: [this.moment().subtract(120, 'day').startOf('day').toDate(), this.moment().subtract(0, 'day').endOf('day').toDate()],
        [this.$gettext('This month')]: [this.moment().startOf('month').toDate(), this.moment().endOf('month').toDate()],
        [this.$gettext('Last week')]: [this.moment().subtract(1, 'week').startOf('week').toDate(), this.moment().subtract(1, 'week').endOf('week').toDate()],
        [this.$gettext('Last month')]: [this.moment().subtract(1, 'month').startOf('month').toDate(), this.moment().subtract(1, 'month').endOf('month').toDate()]
      }
    }
  },
  watch: {
    state: {
      handler () {
        if (this.tabIndex === 0 && !this.quickFilters.manualApply) {
          this.emitQuickFilters()
        }
      },
      deep: true
    }
  },
  created () {
    window.addEventListener('popstate', this.onPopState)
  },
  beforeDestroy () {
    window.removeEventListener('popstate', this.onPopState)
  },
  mounted () {
    this.loadSavedSearches()
    this.$nextTick(() => {
      const query = this.$route.query
      if (query.s) {
        // ListingFilter aplica ?s= por su cuenta en init() y emite refresh
        this.tabIndex = 1
      } else if (query.qf) {
        try {
          this.applyState(JSON.parse(query.qf))
          this.emitIfManualApply()
        } catch (e) {
          console.error(e)
        }
      } else if (query.qs) {
        try {
          this.applyState(this.legacyQuickState(JSON.parse(query.qs)))
          this.emitIfManualApply()
        } catch (e) {
          console.error(e)
        }
      }
    })
  },
  methods: {
    defaults () {
      const state = {}
      for (const filter of this.quickFilters.filters) {
        state[filter.name] = filter.value === undefined ? null : JSON.parse(JSON.stringify(filter.value))
      }
      return state
    },
    isVisible (name) {
      const filter = this.filterByName[name]
      return !filter.showIf || filter.showIf(this.state)
    },
    isDisabled (name) {
      const filter = this.filterByName[name]
      return Boolean(filter.disabledIf && filter.disabledIf(this.state))
    },
    optionsFor (name) {
      const options = this.filterByName[name].options
      return (typeof options === 'function' ? options() : options) || []
    },
    onDateRangeUpdate (name, range) {
      this.state[name].startDate = range.startDate
      this.state[name].endDate = range.endDate
      this.state[name].active++
    },
    resetDateRange (name) {
      // "reset range" vuelve al default declarado del filtro: si el default es
      // activo (tours updated_at) el rango queda activo, como en el fork
      Object.assign(this.state[name], this.defaults()[name])
      this.$set(this.dateRangeMinDates, name, null)
    },
    dateRangeMaxDate (name) {
      const filter = this.filterByName[name]
      if (filter.maxRangeDays && this.dateRangeMinDates[name]) {
        return this.moment(this.dateRangeMinDates[name]).add(filter.maxRangeDays - 1, 'days').format('YYYY-MM-DD')
      }
      return null
    },
    onDateRangeStartSelection (name, date) {
      if (this.filterByName[name].maxRangeDays) {
        this.$set(this.dateRangeMinDates, name, this.moment(date).format('YYYY-MM-DD'))
      }
    },
    onDateRangeToggle (name, show) {
      if (show === false) {
        this.$set(this.dateRangeMinDates, name, null)
      }
    },
    onAutocompleteSelected (name, item) {
      const filter = this.filterByName[name]
      this.state[name].push(
        filter.mapSelected ? filter.mapSelected(item) : { id: item.id, name: item.name, email: item.email }
      )
      const ref = this.$refs['autocomplete-' + name]
      const autocomplete = Array.isArray(ref) ? ref[0] : ref
      if (autocomplete) {
        autocomplete.searchQuery = ''
      }
    },
    emitQuickFilters () {
      const filters = []
      const groups = []
      let suppressCountrize = false
      for (const filter of this.quickFilters.filters) {
        const result = filter.callback(this.state[filter.name], this.state)
        if (!result) {
          continue
        }
        if (Array.isArray(result)) {
          for (const triple of result) {
            filters.push(triple)
          }
          if (filter.suppressesCountrize && result.length > 0) {
            suppressCountrize = true
          }
        } else {
          groups.push(result)
        }
      }
      this.pushQuickQuery()
      this.$emit('filtering', { filters, groups, suppressCountrize })
    },
    pushQuickQuery () {
      const defaults = this.defaults()
      const active = {}
      for (const filter of this.quickFilters.filters) {
        if (JSON.stringify(this.state[filter.name]) !== JSON.stringify(defaults[filter.name])) {
          active[filter.name] = this.state[filter.name]
        }
      }
      const qf = Object.keys(active).length > 0 ? JSON.stringify(active) : undefined
      if ((this.$route.query.qf || undefined) !== qf) {
        this.$router.push({ query: qf ? { qf } : null })
      }
    },
    applyState (partial) {
      const state = this.defaults()
      for (const name of Object.keys(partial)) {
        if (name in state) {
          state[name] = partial[name]
        }
      }
      Object.assign(this.state, state)
    },
    emitIfManualApply () {
      // Con manualApply el watcher de state no emite: los estados restaurados
      // desde la URL o una saved search se aplican explícitamente
      if (this.quickFilters.manualApply) {
        this.emitQuickFilters()
      }
    },
    legacyQuickState (legacyMap) {
      // Formato legacy ?qs= de los forks: {name: [col, op, val]} o
      // {name: [[col, 'in', ids], displayNames]} para los autocompletes
      const state = {}
      for (const name of Object.keys(legacyMap)) {
        const entry = legacyMap[name]
        if (!Array.isArray(entry) || entry.length === 0) {
          continue
        }
        if (entry.length === 2 && Array.isArray(entry[0])) {
          const ids = entry[0][2] || []
          const names = entry[1] || []
          state[name] = ids.map((id, index) => ({ id, name: names[index], email: names[index] }))
        } else if (entry.length === 3) {
          state[name] = entry[2]
        }
      }
      return state
    },
    resetQuickFilters () {
      Object.assign(this.state, this.defaults())
    },
    resetData () {
      Object.assign(this.state, this.defaults())
      if (this.$refs.listingFilter) {
        this.$refs.listingFilter.resetData()
      }
    },
    onAdvancedRefresh (filters) {
      this.$emit('filtering', { filters, groups: [] })
    },
    onPopState () {
      const query = this.$route.query
      if (query.s) {
        this.tabIndex = 1
        let parsed = []
        try {
          parsed = JSON.parse(query.s)
        } catch (e) {
          console.error(e)
        }
        if (this.$refs.listingFilter) {
          this.$refs.listingFilter.advancedFilters = parsed
        }
        this.$emit('filtering', { filters: parsed, groups: [] })
      } else if (query.qf || query.qs) {
        this.tabIndex = 0
        try {
          this.applyState(query.qf ? JSON.parse(query.qf) : this.legacyQuickState(JSON.parse(query.qs)))
          this.emitIfManualApply()
        } catch (e) {
          console.error(e)
        }
      }
    },
    loadSavedSearches () {
      let store = {}
      try {
        store = JSON.parse(localStorage.savedSearches || '{}')
      } catch (e) {
        store = {}
      }
      if (!store[this.type] && this.legacySavedKey && localStorage[this.legacySavedKey]) {
        // Migración lazy: se copian una sola vez al store nuevo, la key legacy queda intacta
        try {
          const legacy = JSON.parse(localStorage[this.legacySavedKey])
          store[this.type] = legacy.map(entry => this.parseLegacySaved(entry)).filter(Boolean)
          localStorage.savedSearches = JSON.stringify(store)
        } catch (e) {
          console.error(e)
        }
      }
      this.savedSearches = store[this.type] || []
    },
    parseLegacySaved (entry) {
      if (!entry || !entry.url) {
        return null
      }
      try {
        const params = new URL(entry.url).searchParams
        if (params.get('qs')) {
          return { name: entry.name, tab: 'quick', state: this.legacyQuickState(JSON.parse(params.get('qs'))) }
        }
        if (params.get('s')) {
          return { name: entry.name, tab: 'advanced', state: JSON.parse(params.get('s')) }
        }
      } catch (e) {
        console.error(e)
      }
      return null
    },
    persistSavedSearches () {
      let store = {}
      try {
        store = JSON.parse(localStorage.savedSearches || '{}')
      } catch (e) {
        store = {}
      }
      store[this.type] = this.savedSearches
      try {
        localStorage.savedSearches = JSON.stringify(store)
      } catch (e) {
        alert(this.$gettext('The Filters couldn\'t be saved'))
      }
    },
    saveCurrentSearch (tab) {
      const name = prompt(this.$gettext('Please set a name for this Filters Set'))
      if (!name) {
        alert(this.$gettext('You must write a name for this Filters Set'))
        return
      }
      const prefix = tab === 'quick' ? 'QUICK: ' : 'ADVANCED: '
      const state = tab === 'quick'
        ? JSON.parse(JSON.stringify(this.state))
        : JSON.parse(JSON.stringify(this.$refs.listingFilter.advancedFilters))
      this.savedSearches.push({ name: prefix + name, tab, state })
      this.persistSavedSearches()
    },
    applySavedSearch (saved) {
      if (saved.tab === 'quick') {
        this.tabIndex = 0
        this.applyState(JSON.parse(JSON.stringify(saved.state)))
        this.emitIfManualApply()
      } else {
        this.tabIndex = 1
        this.$refs.listingFilter.advancedFilters = JSON.parse(JSON.stringify(saved.state))
        this.$refs.listingFilter.emitFilters()
      }
    },
    deleteSavedSearch (index) {
      this.savedSearches.splice(index, 1)
      this.persistSavedSearches()
    }
  }
}
</script>
